



































































































































































































































































































































































































































































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { getSignatureServer, performanceServer, siteManagementServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import html2canvas from 'html2canvas';

@Component
export default class MapWorkMarks extends Vue {
  private visible = false;
  title = '';
  id: any = '';

  row: any = {
    type: '',
  };
  validatorCodeUrl = ''; // 签名图片路径
  a = '（<35ppm）';
  b = '（<10%）';
  c = '（<18%-21%）';

  newDataForm: any = {};
  imgPath: any = 'data:image/jpeg;base64,';
  private URLPath: any = '';
  CellGroupList: any = [];
  AnalysisLimitSpaceList: any = [];
  newAnalysisList: any = [];
  measureTemporaryElectrolList: any = [];
  electroEquipListList: any = [];
  workChoseVideoArr: any = [];
  workVideoChoseData: any = [];
  workNearbyVideoData: any = [];
  videoOption: any = [];
  private applyStaffSignature: any = '';

  // 表单数据
  private formData: any = {
    applyId: '',
    applyStaffId: '',
    applyStaffName: '',
    approvalFlowExampleId: '',
    controlsRecord: [],
    finishFlag: false,
    finishTime: '',
    id: '',
    processLog: [
      {
        actionList: [],
        afterFlowNode: '',
        afterFlowNodeName: '',
        beforeFlowNode: '',
        beforeFlowNodeName: '',
        endTime: '',
        flowExampleId: '',
        id: '',
        memberList: [
          {
            objId: '',
            objName: '',
            type: '',
          },
        ],
        operation: '',
        operationName: '',
        startTime: '',
        withdraw: false,
      },
    ],
    safetyMeasureRecord: [],
    safetyMeasureAnnexData: [],
    taskEndTime: '',
    taskStartTime: '',
    taskUnit: '',
    type: '',
    workOrder: '',
  };

  private processLogData: any = [
    {
      beforeFlowNodeName: '负责人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '审核人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '审批人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '验收评估',
      actionList: [],
    },
  ];

  private otherSafetyMeasure: any = ''; //其他安全措施
  private riskIdentifyValue: any = '';

  private safetyDisclosureArr: any = [];
  private discloserArr: any = [];
  private relevanceOtherValue: any = '';
  private directorUnitNameValue: any = '';
  private projectNameValue: any = '';

  public async showDialog(data: any) {
    this.id = data.id;
    this.title = data.type;
    this.row.type = data.type;
    this.workChoseVideoArr = [];
    this.visible = true;

    this.URLPath = publishObjectPath.imgPathWater;

    // this.setVideoData(data.video);
    this.getData(data);
  }
  // 获取签名图片 根据人员id
  private getStaffSignatureByStaffId() {
    getSignatureServer.getStaffSignatureByStaffId(this.formData.applyStaffId).then((res: any) => {
      if (res.code === '200') {
        if (!res.data) {
          // this.$message.warning('当前人员暂无签名');
        } else {
          this.applyStaffSignature = res.data.signature;
        }
      } else {
      }
    });
  }

  playVideo() {
    // console.log(this.workChoseVideoArr);
    const choseArr: any = [];
    this.workChoseVideoArr.forEach((item: any) => {
      choseArr.push({
        code: item,
        name: '作业票视频',
      });
    });
    this.$emit('videoBack', choseArr);
  }

  setVideoData(videoArr: any) {
    this.workNearbyVideoData = [];
    this.workVideoChoseData = [];
    this.videoOption = [];

    videoArr.forEach((video: any) => {
      if (video.nearby) {
        this.workNearbyVideoData.push(video);
      } else {
        this.workVideoChoseData.push(video);
      }
    });
    if (this.workVideoChoseData.length > 0) {
      this.videoOption.push({
        id: 1,
        label: '已选视频',
        options: this.workVideoChoseData,
      });
    }
    if (this.workNearbyVideoData.length > 0) {
      this.videoOption.push({
        id: 2,
        label: '附近视频',
        options: this.workNearbyVideoData,
      });
    }

    console.log(this.videoOption);
  }

  private async hideDialog() {
    this.visible = false;
  }

  onExport() {
    const clientWidth = (this.$refs as any).imageWrapper.offsetWidth;
    const clientHeight = (this.$refs as any).imageWrapper.offsetHeight;
    const kh = [clientWidth, clientHeight];

    html2canvas((this.$refs as any).imageWrapper, { useCORS: true, logging: true }).then(canvas => {
      const dataURL = canvas.toDataURL('image/png', 1.0);
      this.download(dataURL, kh);
    });
  }

  download(imgUrl: any, kh: any) {
    this.getUrlBase64(imgUrl, kh).then(base64 => {
      const link: any = document.createElement('a');
      link.href = base64;
      link.download = `${this.row.type} - ${this.formData.applyStaffName} -  ${this.formData.workOrder}.jpg`;
      link.click();
    });
  }

  getUrlBase64(url: any, kh: any) {
    return new Promise(resolve => {
      let canvas: any = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = '*'; // 允许跨域
      img.src = url;
      img.onload = () => {
        // eslint-disable-next-line prefer-destructuring
        canvas.height = kh[1];
        // eslint-disable-next-line prefer-destructuring
        canvas.width = kh[0];
        ctx.drawImage(img, 0, 0, kh[0], kh[1]);
        const dataURL = canvas.toDataURL('image/png');
        canvas = null;
        resolve(dataURL);
      };
    });
  }

  getData(data: any) {
    // 通过主键查询单条数据
    siteManagementServer.getSingleSiteManagementData(data.id).then((res: any) => {
      // 中部动态内容处理--开始
      res.data.processLog.splice(0, 1);
      if (res.data.controlsRecord && res.data.controlsRecord.length > 0) {
        res.data.controlsRecord.forEach((r: any, index: any) => {
          if (r.title.indexOf('签名') !== -1) {
            // this.newDataForm.title = item.title;
            // this.getValidatorCode(item.value);
            res.data.controlsRecord.splice(index, 1);
          }
        });

        res.data.controlsRecord.map((item: any, index: any) => {
          if (item.controlsType === 'Radio' || item.controlsType === 'Text' || item.controlsType === 'Input') {
            item.value = item.value;
          }
          if (item.controlsType === 'ChoiceText') {
            let strValue: any = '';
            if (item.value) {
              if (item.value.choice && item.value.choice.length) {
                item.value.choice.forEach((item: any) => {
                  strValue += item.label + '、';
                });
              }
              if (item.value.text) {
                strValue += item.value.text;
              }
            }
            item.value = strValue;
          }

          if (item.controlsType == 'AnalysisLimitSpace') {
            console.log(item, 'AnalysisLimitSpace');
            item.value.forEach(async (i: any) => {
              const resInner: any = await this.getSignatureData(i.sign);
              i.signature = resInner && resInner.signature ? resInner.signature : '';
              this.AnalysisLimitSpaceList.push(i);
            });

            // setTimeout(() => {
            //   this.AnalysisLimitSpaceList = item.value;
            // }, 5000);

            res.data.controlsRecord.splice(index, 1);
          }
          if (item.controlsType == 'CellGroup') {
            this.CellGroupList = item.value;
          }

          if (item.controlsType === 'ContactPerson' || item.controlsType === 'ContactPersonMore') {
            const newArr: any = [];
            item.value.map((itemInner: any) => {
              newArr.push(itemInner.name);
            });
            item.value = newArr.join(', ');
          }

          if (item.controlsType === 'Location') {
            if (item.value && item.value !== '' && item.value !== undefined && item.value !== null) {
              if (this.isJson(item.value)) {
                item.value = JSON.parse(item.value).info;
              } else {
                item.value = item.value.info;
              }
            } else {
              item.value = item.value;
            }
          }
        });
      }

      res.data.processLog.map((r: any, index1: any) => {
        r.actionList.forEach(async (i: any) => {
          const resInner: any = await this.getSignatureData(i.signature);
          i.deptName = resInner && resInner.deptName ? resInner.deptName : '';
          i.postNames = resInner && resInner.postNames ? resInner.postNames : '';
          i.signature = resInner && resInner.signature ? resInner.signature : '';
        });
      });

      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.title === '分析项目') {
          res.data.controlsRecord.splice(index, 1);
        }
        if (r.title === '分析数据') {
          this.newAnalysisList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-measureTemporaryElectro') {
          this.measureTemporaryElectrolList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-electroEquipList') {
          this.electroEquipListList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-otherSafeStep') {
          this.otherSafetyMeasure = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-riskIdentify') {
          if (r.value) {
            if (r.value.choice && r.value.choice.length) {
              r.value.choice.forEach((item: any) => {
                this.riskIdentifyValue += item.label + '、';
              });
            }
            if (r.value.text) {
              this.riskIdentifyValue += r.value.text;
            }
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'WorkTicket-relevanceOther') {
          if (r.value && r.value.length) {
            r.value.forEach((relation: any) => {
              this.relevanceOtherValue += relation.workOrder + '  ';
            });
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-directorUnitName') {
          this.directorUnitNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-projectName') {
          this.projectNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      this.formData = res.data;
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.actionList && item.actionList.length > 0) {
          item.actionList.forEach((img: any) => {
            this.$set(img, 'imgArr', []);
            if (img.images) {
              this.getSysFile(img);
            }
          });
        }
      });
      console.log(res.data.processLog, 'res.data.processLog');
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.beforeFlowNodeName === '安全交底人') {
          this.safetyDisclosureArr = item.actionList;
          res.data.processLog.splice(index, 1);
        }
      });
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.beforeFlowNodeName === '接受交底人') {
          this.discloserArr = item.actionList;
          res.data.processLog.splice(index, 1);
        }
      });
      this.processLogData.forEach((item: any, index: any) => {
        if (res.data.processLog[index]) {
          this.processLogData[index].actionList = res.data.processLog[index].actionList;
        } else {
          this.processLogData[index].actionList = [];
        }
      });
      this.getStaffSignatureByStaffId();

      // 中部动态内容处理--结束
    });
  }

  private getSysFile(data: any) {
    performanceServer.getSysFile(data.images).then((res: any) => {
      if (res.code === '200' && res.data.length > 0) {
        data.imgArr = res.data;
      }
    });
  }

  // 判断是否为json格式
  isJson(data: any) {
    if (typeof data === 'string') {
      try {
        const obj: any = JSON.parse(data);
        if (typeof obj === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  async getValidatorInnerCode(id: any) {
    if (id) {
      const res: any = await performanceServer.getValidatorCode(id);
      return res.data.signature;
    } else {
      return '';
    }
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  // 时间格式处理--年-月-日-时-分
  timeProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return SY + '年' + SM + '月' + SD + '日' + Sh + '时' + Sm + '分';
  }

  // 时间格式处理--时-分
  timeTwoProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return Sh + ':' + Sm;
  }

  imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }
}
